import { Buffer } from 'buffer';

export const encodeUTF8ToBase64 = (data?: string) => Buffer.from(data ?? '', 'utf8').toString('base64');
